import { render, staticRenderFns } from "./AnorettocolonscopiaViewComponent.vue?vue&type=template&id=0113348f"
import script from "./AnorettocolonscopiaViewComponent.vue?vue&type=script&lang=js"
export * from "./AnorettocolonscopiaViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports